module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_1.ec5c8263.png";